import React from 'react';
import IconPopup from './icon-popup';

export default ({
  content,
  showOnHover,
}) => (
  <IconPopup
    content={content}
    outerStyle={{ zIndex: 9999 }}
    innerStyle={{
      color: '#555', lineHeight: '1.4', width: 'initial', maxWidth: '300px', background: '#f9f9f9',
    }}
    iconContainerStyle={{ paddingLeft: '5px', color: 'black', cursor: 'help' }}
    showOnHover={showOnHover}
  />
);
